export enum ServiceProviderType {
  OpenAlex = 'openalex',
  OpenAI = 'openai',
}

export interface ServiceProviderInfo {
  label: string
  type: ServiceProviderType
}
